/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Helmet } from 'react-helmet';
import CorporateBanner from '../../../../components/common/form/CorporateBanner';
import Canonical from '../../../../components/common/layout/Canonical';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSitemap } from '../../../../shared/hooks/use-sitemap';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import PaginationComponent from '../../../../components/common/form/PaginationComponent';
import EmptyList from '../../../../components/common/form/EmptyList';
import { CategoryBg } from '../../../../components/common/svg/AllSvg';
import Error from '../../../../components/common/form/Error';
import useAxios from '../../../../shared/hooks/use-axios';
import { url } from '../../../../shared/utils/url';
import moment from 'moment';

const LotteryResult = () => {
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [page, setPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
    let totalPages: number = Math.ceil(total / +size?.value);
    const loaderData: any[] = [1, 2, 3, 4, 5]
    useSitemap();

    const getLotteryResult = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.lottery_result}?page=${page}&size=${+size?.value}`);

            if (res && res.status === 200) {
                setData(res?.data?.results)
                setTotal(res?.data?.count)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            setIsError(true)
            console.error("error while fetching lottery result", error);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        !!lang && getLotteryResult();
    }, [lang, size, page])

    const isValidDate = (dateString: any) => {
        const date: any = new Date(dateString);
        const valid: boolean = !isNaN(date.getTime())
        if (valid) {
            return moment(dateString).format('DD MMM YYYY')
        } else {
            return dateString
        }
    }

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.lottery_result.title")}</title>
                <meta name="description" content={t("seo_friendly.lottery_result.desc")} />
            </Helmet>
            <div className='bg-white dark:bg-bgDarkDull'>
                <CorporateBanner title={t("corporate.content_pages.lottery_result.title")} root1={t("corporate.content_pages.photo_gallery.home")} root2={t("corporate.content_pages.illustrative_designs.subtitle")} root3={t("corporate.content_pages.lottery_result.title")} />
                <div id="home" className="container corporate-pages">
                    <div className='corporate-content-sec'>
                        {loading ?
                            <div className="overflow-x-auto block">
                                <div className="inline-block min-w-full">
                                    <div className="overflow-hidden">
                                        <table className="min-w-full ">
                                            <thead>
                                                <tr className="border border-[#E7E8EC] dark:border-gray-700 bg-[#F8F8F8] dark:bg-[#3a3f47] border-b-0">
                                                    <th className="px-[11px] xlx:px-[15px] py-[9.5px] text-primaryText dark:text-white font-semibold text-sm text-center">{t("corporate.content_pages.lottery_result.list.lottery_date")}</th>
                                                    <th className="px-[11px] xlx:px-[15px] py-[9.5px] text-primaryText dark:text-white font-semibold text-sm text-left">{t("corporate.content_pages.lottery_result.list.title")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                                    <tr key={index} className="border border-[#E7E8EC] dark:border-gray-700 animate-pulse">
                                                        <td className="px-[11px] xlx:px-[15px] py-[11px] xlx:py-[16px] border-r border-[#E7E8EC] dark:border-gray-700 w-[200px] min-w-[200px] text-center">
                                                            <div className="flex items-center justify-center">
                                                                <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 max-w-[86px]"></div>
                                                            </div>
                                                        </td>
                                                        <td className="px-[11px] xlx:px-[15px] py-[11px] xlx:py-[16px] w-[250px] min-w-[250px] text-left">
                                                            <div className="flex items-center justify-center">
                                                                <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 max-w-[250px]"></div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            :
                            <>
                                {isError ? <Error /> : <>
                                    {data?.length > 0 ? <>
                                        <div className="overflow-x-auto block">
                                            <div className="inline-block min-w-full">
                                                <div className="overflow-hidden">
                                                    <table className="min-w-full ">
                                                        <thead>
                                                            <tr className="border border-[#E7E8EC] dark:border-gray-700 bg-[#F8F8F8] dark:bg-[#3a3f47] border-b-0">
                                                                <th className="px-[11px] xlx:px-[15px] py-[9.5px] text-primaryText dark:text-white font-semibold text-sm text-center">{t("corporate.content_pages.lottery_result.list.lottery_date")}</th>
                                                                <th className="px-[11px] xlx:px-[15px] py-[9.5px] text-primaryText dark:text-white font-semibold text-sm text-left">{t("corporate.content_pages.lottery_result.list.title")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Array.isArray(data) && data.map((item: any, index: number) => (
                                                                <tr key={index} className="border border-[#E7E8EC] dark:border-gray-700">
                                                                    <td className="px-[11px] xlx:px-[15px] py-[11px] xlx:py-[16px] border-r border-[#E7E8EC] dark:border-gray-700 w-[150px] min-w-[150px] text-center text-blackDull dark:text-textBlackDull font-medium text-base break-word">
                                                                        {isValidDate(item?.date)}
                                                                    </td>
                                                                    <td className="px-[11px] xlx:px-[15px] py-[11px] xlx:py-[16px] min-w-[250px] w-full">
                                                                        <div className='flex flex-col gap-[4px] justify-start'>
                                                                            {item?.lottery_results?.length === 1 ?
                                                                                <Link target='_blank' to={item?.lottery_results?.[0]?.result?.file} className='text-[#0E5A81] dark:text-primary font-medium text-base hover:underline focus:underline'>{item?.lottery_results?.[0]?.title}</Link>
                                                                                : <h5 className='text-blackDull dark:text-textBlackDull font-medium text-base break-word'>{item?.title}</h5>}
                                                                            {item?.lottery_results?.length > 1 && <ul className='list-disc flex flex-col gap-[2px] pl-[25px]'>
                                                                                {Array.isArray(item?.lottery_results) && item?.lottery_results.map((i: any, idx: number) => (
                                                                                    <li className='text-[#0E5A81] dark:text-primary font-medium text-base' key={idx}><Link target='_blank' to={i?.result?.file} className='hover:underline focus:underline font-medium text-base'>{i?.title}</Link></li>
                                                                                ))}
                                                                            </ul>}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-center w-full mt-[10px]">
                                            <PaginationComponent
                                                page={page}
                                                total={totalPages}
                                                setPage={setPage}
                                            />
                                        </div>
                                    </> :
                                        <EmptyList />
                                    }
                                </>}
                            </>
                        }
                    </div>

                    <div className="menu-sec">
                        <div className="menu-title">
                            <div className="bg">
                                <CategoryBg />
                            </div>

                            <h5>{t("corporate.content_pages.project_menu.rehabilitation_resettlement")}</h5>
                        </div>
                        <a className="inactive" href="/corporate/pages/flgrc-slgrc">{t("corporate.content_pages.project_menu.flgrc_slgrc")}</a>
                        <a className="inactive" href="/corporate/pages/public-consultation">{t("corporate.content_pages.project_menu.public_consultation")}</a>
                        <a className="inactive" href="/corporate/pages/final-bses">{t("corporate.content_pages.project_menu.final_bses")}</a>
                        <a className="active" href="/corporate/pages/lottery-result"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="14" viewBox="0 0 5 14" fill="none">
                            <path d="M2.354 2.25488L2.354 11.4967" stroke-width="4" stroke-linecap="round" />
                        </svg>{t("corporate.content_pages.project_menu.lottery_result")}</a>
                        <a className="inactive" href="/corporate/pages/policy-list">{t("corporate.content_pages.project_menu.policy_list")}</a>
                        <a className="inactive" href="/corporate/pages/in-situ-rr-office-address">{t("corporate.content_pages.project_menu.in_situ_rr_office_address")}</a>
                        <a className="inactive" href="/corporate/pages/bses-survey-maps">{t("corporate.content_pages.project_menu.bses_survey_maps")}</a>
                        <a className="inactive" href="/corporate/pages/building-wise-allotment-list">{t("corporate.content_pages.project_menu.building_wise_allotment_list")}</a>
                        <a className="inactive" href="/corporate/pages/rehabilitation-building-occupation">{t("corporate.content_pages.project_menu.rehabilitation_building_occupation")}</a>
                        <a className="inactive" href="/corporate/pages/public-notices"> {t("corporate.content_pages.project_menu.public_notices")}</a></div>
                </div>
            </div>
        </>
    );
};

export default LotteryResult;